import { Button, Dialog, DialogActions, DialogContent, DialogContentText, useMediaQuery, Typography  } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export const DeletePrompt = (props: any) => {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const handleClose = () => {
        props.onClose();
    };

    return (
        <div>
            <Dialog
                fullScreen={fullScreen}
                open={props.open}
                onClose={props.onClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogContent>
                    <DialogContentText>
                    <Typography variant="body1" gutterBottom> {props.billingGroupEnable ? <>User updates on grouped tests will be lost. Is it okay to continue?</> : <>This operation will delete the table and the values captured within.<br/> Do you want to proceed?</>}</Typography>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>                    
                    <Button variant="contained" color="primary" onClick={props.handleTableDelete} autoFocus>
                        Yes
                    </Button>
                    <Button autoFocus variant="contained" color="error" onClick={handleClose}>
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
